import React from "react";
import logo from "../assets/logo.png";
import logoRight from "../assets/logo-right.png";
import IconOne from "../assets/icon-1.png";
import IconTwo from "../assets/icon-2.png";
import IconThree from "../assets/icon-3.png";
import BgMain from "../assets/bg_main.jpg";

const menu = [
  {
    title: "Giới thiệu",
    items: [
      { title: "Pháp lý", location: "/legality" },
      { title: "Tầm nhìn - Sứ mạng - Giá trị cốt lõi", location: "/vision" },
      { title: "Tin tức - Sự kiện", location: "/news" },
      { title: "Thành tích", location: "/reward" },
    ],
  },
  {
    title: "Chương trình đào tạo",
    location: "/curriculum",
    items: [],
  },
  {
    title: "Giáo viên",
    location: "/teacher",
    items: [],
  },
  {
    title: "Kỹ năng sống",
    items: [],
  },
  {
    title: "Thông tin công khai",
    location: "thongtincongkhai.pdf",
    items: [],
  },
  // {
  //   title: "Tài liệu giảng dạy",
  //   location: "/document",
  //   items: [],
  // },
];

const MenuBar = () => (
  <div className="flex items-start gap-4 px-4 p-4">
    {menu.map((m, idx) => (
      <div key={m.title} className="relative group">
        <button
          className="relative font-bold text-blue-900 text-lg px-2 py-1 focus:outline-none transition-colors duration-200 hover:text-blue-600 after:content-[''] after:absolute after:left-2 after:right-2 after:-bottom-0.5 after:h-0.5 after:bg-blue-600 after:scale-x-0 after:origin-left after:transition-transform after:duration-200 hover:after:scale-x-100"
          onClick={() => {
            if (m.location) {
              window.location.href = m.location;
            }
          }}
        >
          {m.title}
          {m.items.length > 0 && (
            <span className="ml-1 inline-block -rotate-90 transition-transform duration-200 group-hover:rotate-0">
              ▼
            </span>
          )}
        </button>
        {m.items.length > 0 && (
          <div className="absolute left-0 top-8 z-10 bg-white border-2 border-blue-500 rounded-xl shadow-lg p-3 w-64 origin-top opacity-0 invisible -translate-y-2 scale-95 transition-all duration-200 ease-out group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 group-hover:scale-100">
            {m.items.map((item) => (
              <div
                onClick={() => {
                  console.log(item.title);
                  if (item.location) {
                    window.location.href = item.location;
                  }
                }}
                key={item.title}
                className="font-bold text-blue-800 py-1 px-2 rounded-md hover:bg-blue-50 hover:pl-3 hover:underline cursor-pointer transition-all duration-150"
              >
                {item.title}
              </div>
            ))}
          </div>
        )}
      </div>
    ))}
  </div>
);

const Homepage = () => {
  return (
    <div className="min-h-screen bg-gray-100 font-sans text-gray-800 flex flex-col items-center py-8 px-4 sm:px-6 lg:px-8">
      {/* Header Section */}
      <header className="w-full max-w-7xl mb-12">
        <div className="flex flex-col md:flex-row items-center justify-between mb-8">
          <img
            src={logo}
            alt="Logo"
            width="50%"
            className="flex items-center space-x-4 mb-6 md:mb-0 animate-fade-in-up transition-transform duration-300 hover:scale-105"
          />
          <img
            src={logoRight}
            alt="logoRight"
            width="50%"
            className="flex flex-col items-end text-right animate-fade-in-up [animation-delay:150ms] transition-transform duration-300 hover:scale-105"
          />
        </div>
      </header>

      {/* Main Content Section - Hexagonal Cards */}
      <main className="w-full max-w-7xl grid grid-cols-1 md:grid-cols-3 gap-8 px-4">
        <img
          src={IconThree}
          alt="logoRight"
          className="animate-fade-in-up [animation-delay:100ms] transition-all duration-300 ease-out cursor-pointer hover:scale-105 hover:-translate-y-1 hover:drop-shadow-2xl"
        />
        <img
          src={IconOne}
          alt="logoRight"
          className="animate-fade-in-up [animation-delay:250ms] transition-all duration-300 ease-out cursor-pointer hover:scale-105 hover:-translate-y-1 hover:drop-shadow-2xl"
        />
        <img
          src={IconTwo}
          alt="logoRight"
          className="animate-fade-in-up [animation-delay:400ms] transition-all duration-300 ease-out cursor-pointer hover:scale-105 hover:-translate-y-1 hover:drop-shadow-2xl"
        />
      </main>
      <div className="w-full max-w-7xl mb-12">
        <MenuBar />
        <div className="overflow-hidden rounded-lg shadow-md">
          <img src={BgMain} alt="Logo" width="100%" />
        </div>
      </div>

      <footer className="w-full max-w-7xl mb-12 bg-white p-6 rounded-lg shadow-md mt-12 transition-shadow duration-300 hover:shadow-xl">
        <div className="text-left text-gray-600 text-sm">
          <span>
            CÔNG TY TNHH MỘT THÀNH VIÊN TƯ VẤN DỊCH VỤ GIÁO DỤC VÀ DU LỊCH TÂN
            VĂN
          </span>
          <br />
          <span>Mã số thuế 0309867461</span>
          <br />
          <span>
            Địa chỉ 84/20 đường 18, khu phố 3, phường Hiệp Bình, Tp. Hồ Chí Minh
          </span>
        </div>
      </footer>
    </div>
  );
};

export default Homepage;
